'use client'
import { useIsLoggedInQuery } from 'auth/hooks'

import { ShowJoinModal } from './show-join-modal'

export function ShowJoinClient({ slug }: { slug: string }) {
  const isLoggedInQuery = useIsLoggedInQuery()
  return (
    <>{isLoggedInQuery.isFetched && isLoggedInQuery.data ? <ShowJoinModal slug={slug} /> : null}</>
  )
}
